import { timelineSteps } from '@/mocks/content';

const phaseColor: Record<string, string> = {
  起点: 'bg-secondary-500',
  发酵: 'bg-primary-400',
  升温: 'bg-primary-500',
  引爆: 'bg-accent-500',
  沉淀: 'bg-background-400',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
              <i className="ri-node-tree" />
              事件脉络
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">一个热点是怎样发酵到登顶的</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              热点从不凭空出现。下面用一条典型的发酵路径，带你理解从信号初现到结论沉淀的完整节奏，
              这也是看料站持续跟进事件、不遗漏关键节点的方法。
            </p>
            <div className="mt-6 rounded-2xl border border-background-200 bg-background-100/70 p-5">
              <div className="flex items-center gap-3">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-accent-500 text-background-50">
                  <i className="ri-sparkling-line" style={{ fontSize: 20 }} />
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">「先看信号，再看声量」</p>
                  <p className="text-xs text-foreground-600">用最短路径判断一件事要不要跟进</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                出现"讨论张力 + 快速扩散 + 多方补充"三要素的话题，往往最容易快速升温。遇到这类信号，速报的更新就会明显加密。
              </p>
            </div>
          </div>

          <ol className="relative border-l-2 border-background-200 pl-8">
            {timelineSteps.map((step) => (
              <li key={step.phase} className="relative pb-8 last:pb-0">
                <span
                  className={`absolute -left-[41px] grid h-6 w-6 place-items-center rounded-full ring-4 ring-background-50 ${phaseColor[step.phase]}`}
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-background-100 px-3 py-1 text-xs font-bold text-primary-700">
                    {step.phase}
                  </span>
                  <span className="text-xs font-medium text-foreground-400">{step.time}</span>
                </div>
                <h3 className="mt-2 text-lg font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}